import { createContext, useContext } from 'react'
import { FlightsClassTypes } from 'constants/flight'
import noop from 'lib/function/noop'

interface MaldivesDirectBundleContextValue {
  charterBundle: boolean
  isPricePerPerson: boolean
  fareClass: FlightsClassTypes
  departureAirportCode?: string
  duration?: number
  allowedFareClassesByOfferId: Map<string, Array<FlightsClassTypes>>
  hasFareClassRestrictionsByOfferId: Map<string, boolean>
  canOpenFareClassModal: boolean
  openFareClassModal: () => void
}

export const EMPTY_FARE_CLASS_MAP = new Map<string, Array<FlightsClassTypes>>()
export const EMPTY_RESTRICTIONS_MAP = new Map<string, boolean>()

const MaldivesDirectBundleContext = createContext<MaldivesDirectBundleContextValue>({
  charterBundle: false,
  isPricePerPerson: true,
  fareClass: FlightsClassTypes.ECONOMY,
  departureAirportCode: undefined,
  duration: undefined,
  allowedFareClassesByOfferId: EMPTY_FARE_CLASS_MAP,
  hasFareClassRestrictionsByOfferId: EMPTY_RESTRICTIONS_MAP,
  canOpenFareClassModal: false,
  openFareClassModal: noop,
})

export const MaldivesDirectBundleProvider = MaldivesDirectBundleContext.Provider

export function useMaldivesDirectBundleContext(): MaldivesDirectBundleContextValue {
  return useContext(MaldivesDirectBundleContext)
}
